// extracted by mini-css-extract-plugin
module.exports = {"group":"_4e47a3d"};